export default function deepParse (stringObject) {
  let object = stringObject;

  const isParsing = (parsingObject) => {
    return typeof parsingObject === 'string';
  };

  while (isParsing(object)) {
    object = JSON.parse(object);
  }

  return object;
}

export const returnUnlinkedObject = (object) => {
  return deepParse(JSON.stringify(object));
};
